export default __webpack_public_path__ + "static/media/1.566951df.png";